import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import FormCad from '../../../../components/auth/projetocultural/form_cad'


function CadastrarProjetoCulturalScreen() {

    return (
        <Fragment>
            <Head titulo="Cadastrar Projeto Cultural" />
            <HeaderLogged />
            <Container>
               <FormCad />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default CadastrarProjetoCulturalScreen;